import { render, staticRenderFns } from "./DatasetListCard.vue?vue&type=template&id=783c9aa3&scoped=true&"
import script from "./DatasetListCard.vue?vue&type=script&lang=js&"
export * from "./DatasetListCard.vue?vue&type=script&lang=js&"
import style0 from "./DatasetListCard.vue?vue&type=style&index=0&id=783c9aa3&prod&lang=scss&scoped=true&"
import style1 from "./DatasetListCard.vue?vue&type=style&index=1&id=783c9aa3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783c9aa3",
  null
  
)

export default component.exports